import { render } from "./PsNavBar.vue?vue&type=template&id=2bd204ff"
import script from "./PsNavBar.vue?vue&type=script&lang=js"
export * from "./PsNavBar.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\DELL\\download\\advertisingServiceWebApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__